import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const BILLING_PATH = "/billing/v1";

export const getBillingByIdApi = async (body) => {
  return await getRequest(`${BILLING_PATH}/${body?.id}`);
};

export const paymentByIdApi = async (id, body) =>
  await postRequest(`${BILLING_PATH}/${id}/payment`, body);
export const refundByIdApi = async (id, body) =>
  await postRequest(`${BILLING_PATH}/${id}/refund`, body);
export const cancelExpensesByIdApi = async (id, body) =>
  await postRequest(`${BILLING_PATH}/${id}/cancel-expenses`, body);
export const generateBillingByIdApi = async (id, body) =>
  await postRequest(`${BILLING_PATH}/${id}/generate-bill`, body);
export const reopenBillingByIdApi = async (id, body) =>
  await postRequest(`${BILLING_PATH}/${id}/reopen-bill`, body);

export const printSummaryBillApi = async (id) => {
  try {
    const response = await getRequest(`${BILLING_PATH}/invoice/${id}/summary-bill/pdf`, {}, { responseType: 'arraybuffer' });
    return response;
  } catch (error) {
    console.error("Error in printSummaryBillApi:", error);
    return { error: true, message: error.message };
  }
};

export const printPaymentPrintApi = async (id) => {
  try {
    const response = await getRequest(`${BILLING_PATH}/payment/${id}/receipt/pdf`, {}, { responseType: 'arraybuffer' });
    return response;
  } catch (error) {
    console.error("Error in printPaymentPrintApi:", error);
    return { error: true, message: error.message };
  }
};
